import React, { useState, useEffect } from "react";
import { createTheme, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Controls from "../controls/Controls";
import { useForm, Form } from "../customHelpers/useForm";
import PurchaseProduct from "../../actions/purchaseProduct";
import Store from "../../actions/store";
const theme = createTheme();

const initialFValues = {
  store_id: "",
};
const useStyles = makeStyles(() => ({
  root: {
    "& .MuiFormControl-root": {
      width: "80%",
      margin: theme.spacing(1),
    },
  },
}));

const PublishPurchaseProductForm = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  getAllProducts,
  purchaseOrderId,
  selectedProducts,
}) => {
  const classes = useStyles();
  const { publishPurchaseProducts } = PurchaseProduct();
  const { viewAllStores } = Store();
  const [stores, setStores] = useState([]);

  useEffect(() => {
    viewAllStores().then((data) => {
      if (data.stores) {
        setStores(data.stores);
      }
    });
  }, []);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("store_id" in fieldValues)
      temp.store_id = fieldValues.store_id ? "" : "This field is required.";
    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      publishPurchaseProducts({
        storeId: values.store_id,
        purchaseOrderId: purchaseOrderId,
        products: selectedProducts,
      }).then((data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else if (data.errors) {
          NotifyMessage({
            message: data.errors[0],
            type: "error",
          });
        } else {
          NotifyMessage({
            message: "Purchase product published successfully",
            type: "success",
          });
          setOpenPopup(false);
          getAllProducts();
        }
      });
    }
  };

  return (
    <Form className={classes.root} onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.SelectStore
            name="store_id"
            label="Store"
            value={values.store_id}
            onChange={handleInputChange}
            options={stores}
            error={errors.store_id}
          />
          <div>
            <Controls.Button
              type="submit"
              text="Publish"
            />
            <Controls.Button
              text="Cancel"
              color="default"
              onClick={() => setOpenPopup(false)}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default PublishPurchaseProductForm;
